import type { ComponentProps } from "react";
import "./styles.scss";
import { observer } from 'mobx-react';
import { UiPopup } from 'shared/uikit-new/UiPopup';

type Props = ComponentProps<typeof UiPopup>;

export const PPDModal = observer((props: Props) => {
    return (
        <UiPopup {...props}>
            {props.children}
        </UiPopup>
    );
});
